import { Module, GetterTree, MutationTree, ActionTree, Mutation } from "vuex";
import store, { RootState, Nullable } from "../../store/index";
import customAxios from "@/axios-service";

export interface DashboardData {
  x: string;
  y: number | string;
}
export interface DashboardInfo {
  dashboard_info: {
    energy_consumption_24_hours: DashboardData[];
    energy_gas_consumption_24_hours: DashboardData[];
    energy_production_24_hours: DashboardData[];
  };
  overall_info?: Nullable<{
    total_energy_consumed: number;
    total_energy_produced: number;
    total_injected_energy: number;
    total_monitored_households: number;
  }>;
}

export const state: DashboardInfo = {
  dashboard_info: JSON.parse(
    sessionStorage.getItem("dashboard-info") || "null"
  ),
  overall_info: JSON.parse(
    sessionStorage.getItem("overall-dashboard-info") || "null"
  ),
};

const getters: GetterTree<DashboardInfo, RootState> = {
  dashboardInfo: (state) => {
    return state.dashboard_info;
  },
  overallDashboardInfo: (state) => {
    return state.overall_info;
  },
};

const mutations: MutationTree<DashboardInfo> = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateDashboardInfo: (state, value: any) => {
    if (!value) return;
    state.dashboard_info = value;
    sessionStorage.setItem(
      "dashboard-info",
      JSON.stringify(state.dashboard_info)
    );
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setOverallDashboardInfo: (state, value: any) => {
    if (!value) return;
    state.overall_info = value;
    sessionStorage.setItem(
      "overall-dashboard-info",
      JSON.stringify(state.overall_info)
    );
  },
};

const actions: ActionTree<DashboardInfo, RootState> = {
  async getDashboardInfo({ commit }) {
    return customAxios
      .get(`/api/dashboard_data`)
      .then((response) => {
        if (response.data && response.data.energy_consumption_24_hours) {
          response.data.energy_consumption_24_hours.profile.map((obj: any) => {
            if (!!response.data.energy_consumption_24_hours.total && !obj.y) {
              obj.y = 0;
            }
            return obj;
          });
        }
        if (response.data && response.data.energy_production_24_hours) {
          response.data.energy_production_24_hours.profile.map((obj: any) => {
            if (!!response.data.energy_production_24_hours.total && !obj.y) {
              obj.y = 0;
            }
            return obj;
          });
        }
        if (response.data && response.data.energy_gas_consumption_24_hours) {
          response?.data?.energy_gas_consumption_24_hours?.profile.map(
            (obj: any) => {
              if (
                !!response.data.energy_gas_consumption_24_hours.total &&
                !obj.y
              ) {
                obj.y = 0;
              }
              return obj;
            }
          );
        }
        return commit("updateDashboardInfo", response.data);
      })
      .catch((e) => {
        return store.dispatch("formResponseError", e);
      });
  },
  async getOverallDashboardInfo({ commit }) {
    return customAxios
      .get(`/api/dashboard_data_total`)
      .then((response) => {
        if (!response.data) return;
        return commit("setOverallDashboardInfo", response.data);
      })
      .catch((e) => {
        return store.dispatch("formResponseError", e);
      });
  },
};

const namespaced = true;

const dashboardData: Module<DashboardInfo, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};

export default dashboardData;
